import Vue from 'vue'
import VueI18n from 'vue-i18n'

import en from './en.json'
import ru from './ru.json'
import ua from './ua.json'
import params from '../../public/site_config.json'

Vue.use(VueI18n)

const locale = params.initial_lang

const messages = {
    en: en,
    ru: ru,
    ua: ua
}

const i18n = new VueI18n({
    locale,
    messages
})

export default i18n